import cn from 'classnames';
import React, {forwardRef} from 'react';
import {InputProps, MaskedInput} from '../Input';
import styles from './CardInput.module.css';

const mask = [
	/\d/,
	/\d/,
	/\d/,
	/\d/,
	' ',
	/\d/,
	/\d/,
	/\d/,
	/\d/,
	' ',
	/\d/,
	/\d/,
	/\d/,
	/\d/,
	' ',
	/\d/,
	/\d/,
	/\d/,
	/\d/,
];

export const CardInput = forwardRef<HTMLInputElement, InputProps>(function CardInput({value, onChange}, ref) {
	const strValue = String(value);

	return (
		<MaskedInput
			mask={mask}
			ref={ref}
			value={strValue}
			classes={{
				root: styles.inputRoot,
				nativeInput: cn(styles.input, 'p-0 bg-transparent', {[styles.placeholder]: !strValue.length}),
			}}
			name={'card'}
			onChange={onChange}
			placeholder={'0000 0000 0000 0000'}
			autoSave={'off'}
			inputMode={'numeric'}
		/>
	);
});
